<template>
    <div id="report-agent-activities">
        <div class="overall-content">
            <div class="chart-container">
                <div class="report-card">
                    <div class="report-card-header">
                        <div class="report-card-icon activity-icon">
                            <md-icon>assessment</md-icon>
                        </div>
                        <div class="report-card-title">
                            <h2>{{ $t('report.dailyAgentActivity') }}</h2>
                            <p class="report-card-subtitle">{{ $t('report.agentActivitiesDesc') }}</p>
                        </div>
                    </div>
                    <div class="report-card-body">
                        <AgentActivitiesReportCard :filters="filters" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import log2 from "../../../utils/log2";
import moment from "moment";
import AgentActivitiesReportCard from "./AgentActivitiesReportCard.vue";

const log = log2("AgentActivitiesReport");
export default {
    name: "AgentActivitiesReport",
    components: { AgentActivitiesReportCard },
    props: {
        filters: {
            type: Object,
            default: () => ({
                users: [],
                channels: [],
                startDate: moment().startOf("day").toISOString(),
                endDate: moment().endOf("day").toISOString(),
            }),
        },
    },
    data() {
        return {};
    },

    methods: {},
    mounted() {},
    watch: {
        filters: {
            handler: function (val, oldVal) {},
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
#report-agent-activities {
    width: 100%;
    height: auto;
    min-height: 100vh;
    display: flex;

    .overall-content {
        padding: 16px;
        display: flex;
        flex-direction: column;
        background: var(--color-bg-neutral, #f5f5f5);
        width: 100%;
        min-height: 100vh;

        .chart-container {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 24px;

            .report-card {
                background: #fff;
                border-radius: 12px;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06);
                overflow: hidden;
                transition: box-shadow 0.2s ease;

                &:hover {
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06);
                }

                .report-card-header {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    padding: 20px 24px;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.06);

                    .report-card-icon {
                        width: 44px;
                        height: 44px;
                        border-radius: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-shrink: 0;

                        i {
                            font-size: 22px !important;
                            color: #fff;
                        }

                        &.activity-icon {
                            background: linear-gradient(135deg, #3b82f6, #2563eb);
                        }
                    }

                    .report-card-title {
                        h2 {
                            font-size: 18px;
                            font-weight: 600;
                            margin: 0;
                            color: #1a1a1a;
                        }

                        .report-card-subtitle {
                            font-size: 13px;
                            color: #6b7280;
                            margin: 2px 0 0 0;
                        }
                    }
                }

                .report-card-body {
                    padding: 20px 24px;
                }
            }
        }
    }
}
</style>
